// Figma source https://www.figma.com/file/0MhPskmJ0pxL0vEYg0Qrrn/Siit---WIP?node-id=2%3A11332
export const paperBoxShadow = '0px 4px 4px rgba(0, 0, 0, 0.04), 0px 4px 32px rgba(0, 0, 0, 0.02)';
export const cardBoxShadow = '0px -2px 52px rgba(10, 16, 23, 0.04), 0px 4px 32px rgba(10, 16, 23, 0.02);';
export const themeBorderRadius = 8;

export const defaultBorderRadius = '0.8rem';

export const sidebarWidth = 24; // rem
export const mainContentPadding = 3; // x time

export const htmlFontSize = 10;
